// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".reciever-channels-row{display:flex}.reciever-channels-row .reciever-col{border-right:1px solid #e7e7e7}.reciever-channels-row .reciever-channels-col{background-color:#fff;height:62px;max-width:233px!important}.reciever-channels-row .reciever-add-col{border-left:1px solid #e7e7e7;max-width:60px!important}.channel-drop-down-menu{border:1px solid #d8d8d8;border-radius:0 0 8px 8px;box-shadow:0 2px 4px 0 rgba(0,0,0,.12)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
